module.exports = __webpack_public_path__ + "static/media/print.1dfb4689.svg";